import { PipeableArray } from './pipeable_array.js';
import { ArrayCompositionPipeableMixin } from './array_composition_pipeable_mixin.js';

const ArrayCompositionPipeableArray =
  ArrayCompositionPipeableMixin(PipeableArray);

export { ArrayCompositionPipeableArray };
